import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from "react-router-dom";
import { makeStyles, useTheme, Paper, Typography, IconButton } from '@material-ui/core';
import iconUpDark from "../../../images/iconTrendUpGreenDark.png";
import iconUpLight from '../../../images/iconTrendUpGreenLight.png';
import iconDownDark from "../../../images/iconTrendDownRedDark.png";
import iconDownLight from "../../../images/iconTrendDownRedLight.png";
import wrenchLight from "../../../images/wrenchLight.svg";
import { themeTypeToBool } from '../../../utils/helpers';
import moreIcon from '../../../images/moreIcon.png';
import { bindActionCreators } from "redux";
import ActionCreator from './../../../store/actions/index';
import { connect } from "react-redux";

const useStyles = makeStyles((theme) => ({
    container: {
        minWidth: 350,
        height: 130,
        marginTop: theme.spacing(1),
        margin: theme.spacing(1),
        background: theme.palette.background.paper,
        position: "relative"
    },
    title: {
        position: "absolute",
        bottom: 15,
        left: 100,
        marginLeft: theme.spacing(1)
    },
    icon: {
        height: 80,
        position: "absolute",
        top: 25,
        left: 10
    },
    mainInfo: {
        position: "absolute",
        top: 30,
        left: 100,
        fontWeight: 600,
        marginLeft: theme.spacing(2)
    },
    moreIcon: {
        position: "absolute",
        right: 15,
        top: 45
    }
}));

const evaluateBalanceIcon = (themeType, trend) => {
    switch (trend) {
        case "up":
            return themeTypeToBool(themeType) ? iconUpLight : iconUpDark;
        case "down":
            return themeTypeToBool(themeType) ? iconDownLight : iconDownDark;
        default:
            return themeTypeToBool(themeType) ? wrenchLight : wrenchLight;
    }
};

const evaluateInfoColor = (themeType, trend) => {
    switch (trend) {
        case "up":
            return "#4AD991";
        case "down":
            return "#F53C56";
        default:
            return "#56d9fe";
    }
};

function ValueIndicator(props) {
    const theme = useTheme();
    const classes = useStyles(theme);
    const { title, value = "", trend, btnVisible = true, data } = props;
    const [text, setText] = useState("");

    const handleRedirectToCarsView = () => {
        if (data !== null) {
            // let registrationNos = [];
            // if (data.serwis !== null)
            //     registrationNos = [...registrationNos, ...data.serwis.auta];
            // if (data.blokada !== null)
            //     registrationNos = [...registrationNos, ...data.blokada.auta];
            // if (data.panic !== null)
            //     registrationNos = [...registrationNos, ...data.panic.auta];
            // registrationNos = registrationNos.join(";");
            props.showArchivedFilter();
            props.showInServiceFilter();
            props.history.push({
                pathname: "/cars",
                //search: `?ids=${registrationNos}`
            });
        }
    };

    useEffect(() => {
        setText(value);
    }, [value]);

    return (
        <Paper className={classes.container} square>
            <img
                src={evaluateBalanceIcon(theme.palette.type, trend)}
                alt="trendIcon"
                className={classes.icon} />
            <Typography variant="h4" className={classes.mainInfo} style={{ color: evaluateInfoColor(theme.palette.type, trend) }}>
                {text}
            </Typography>
            <Typography variant="subtitle2" className={classes.title}>
                {title}
            </Typography>
            <IconButton
                className={classes.moreIcon}
                style={{ display: btnVisible ? "block" : "none" }}
                onClick={handleRedirectToCarsView}
            >
                <img src={moreIcon} alt="detailsIcon" style={{ width: 40 }} />
            </IconButton>
        </Paper>
    );
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

export default connect(null, mapDispatchToProps)(withRouter(ValueIndicator));

ValueIndicator.propTypes = {
    title: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    trend: PropTypes.oneOf(["up", "down"]),
    btnVisible: PropTypes.bool,
    data: PropTypes.object,
    showArchivedFilter: PropTypes.func,
    showInServiceFilter: PropTypes.func,
    //router
    history: PropTypes.object
};
